import { RichText, InnerBlocks } from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";
import {STANDARD_RICHTEXT_FORMATS} from "~buildable/utils/constants";

const TitleSubtitleParagraph = props => {
  const {
    className = "",
    title,
    titlePlaceholder = "Title",
    titleKey = 'title',
    titleTag = 'h2',
    subtitle,
    subtitlePlaceholder = "Subtitle",
    subtitleKey = 'subtitle',
    subtitleTag = 'h3',
    paragraph,
    paragraphPlaceholder = "Paragraph",
    paragraphKey = 'paragraph',
    noSubtitle = false,
    swapTitleAndSubtitleLocations = false,
    setAttributes
  } = props;

  const titleElement = (
    <RichText
      tagName={ titleTag }
      className="buildable__title"
      value={ title }
      onChange={ title => setAttributes({ [titleKey]: title }) }
      placeholder={ __( titlePlaceholder ) }
      allowedFormats={ STANDARD_RICHTEXT_FORMATS }
      key="tsp_title"
      keepPlaceholderOnFocus
    />
  );

  const subtitleElement = ! noSubtitle ? (
    <RichText
      tagName={ subtitleTag }
      className="buildable__subtitle"
      value={ subtitle }
      onChange={ subtitle => setAttributes({ [subtitleKey]: subtitle }) }
      placeholder={ __( subtitlePlaceholder ) }
      allowedFormats={ STANDARD_RICHTEXT_FORMATS }
      key="tsp_subtitle"
      keepPlaceholderOnFocus
    />
  ) : null;

  const titleSubtitleElements = ! swapTitleAndSubtitleLocations
    ? [titleElement, subtitleElement]
    : [subtitleElement, titleElement];

  return (
    <div className={ `title-subtitle-paragraph ${className}` }>
      { titleSubtitleElements }

      <RichText
        tagName="p"
        className="buildable__paragraph"
        value={ paragraph }
        onChange={ paragraph => setAttributes({ [paragraphKey]: paragraph }) }
        placeholder={ __( paragraphPlaceholder ) }
        allowedFormats={ STANDARD_RICHTEXT_FORMATS }
        key="tsp_paragraph"
        keepPlaceholderOnFocus
      />
    </div>
  )
}

export default TitleSubtitleParagraph;
